import React from "react";
import { EntityBankAccountCard } from "../EntityBankAccountCard";
import { EntityBankAccountFragment } from "../types";

export interface EntityBankAccountDisplayProps {
  selectedEntity?: EntityBankAccountFragment | null;
  bankAccountUrl?: string | null;
}

export const EntityBankAccountDisplay: React.FC<EntityBankAccountDisplayProps> = ({
  selectedEntity,
  bankAccountUrl,
}) => {
  if (!selectedEntity?.bankAccount) {
    return null;
  }

  return (
    <EntityBankAccountCard
      bankAccount={selectedEntity.bankAccount}
      bankAccountUrl={bankAccountUrl}
    />
  );
};
